import React from "react";
import { Typography, TableRow, Checkbox, TableCell, Chip, Grid, Box } from "@material-ui/core";
import { ExamDayViewModel } from "../../model/ExamDayViewModel";
import { areDatesEqual } from "../../utils/Dates";
import { LocationViewModel } from "../../model/LocationViewModel";
import { ExamTemplateIndex } from "../../model/Exam";
import { GetTranslatedValue } from "../../model/Shared/TranslatedValue";

export type CellData = FullCellData | EmptyCellData;

export class FullCellData {
  isChecked: boolean;
  examDay: ExamDayViewModel;
  examIds: string[];

  constructor(isChecked: boolean, examDay: ExamDayViewModel, examIds: string[]) {
    this.isChecked = isChecked;
    this.examDay = examDay;
    this.examIds = examIds;
  }
}

export class EmptyCellData {}

interface ExpertAvailabilityRowProps {
  location: LocationViewModel;
  cells: CellData[];
  availableExamDays: ExamDayViewModel[];
  selectedExamDayIds: string[];
  allSessionExams: ExamTemplateIndex[];
  onChange: (checkedItems: string[]) => void;
}

const isDateAlreadySelected = (
  availableExamDays: ExamDayViewModel[],
  selectedExamDayIds: string[],
  newSelectedExamDay: ExamDayViewModel
) => {
  const selectedExamDays = availableExamDays.filter((day) => selectedExamDayIds.includes(day.id));
  const existingDate = selectedExamDays.find((day) => areDatesEqual(day.date, newSelectedExamDay.date));
  return existingDate;
};

const ExpertAvailabilityRow: React.FunctionComponent<ExpertAvailabilityRowProps> = ({
  availableExamDays,
  location,
  cells,
  selectedExamDayIds,
  allSessionExams,
  onChange,
}) => {
  const handleChange =
    (changedExamDay: ExamDayViewModel) => (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      if (checked && !isDateAlreadySelected(availableExamDays, selectedExamDayIds, changedExamDay)) {
        onChange([...selectedExamDayIds, changedExamDay.id]);
      } else {
        onChange([...selectedExamDayIds.filter((examDayId) => examDayId !== changedExamDay.id)]);
      }
    };

  function cellContent(cellData: FullCellData) {
    function getExamName(examId: string) {
      const exam = allSessionExams.find((e) => e.id === examId);
      if (!exam) return "";
      return GetTranslatedValue(exam.name);
    }

    return (
      <Box borderColor="#000000" border="2px solid" padding="8px" height="100%">
        <Grid container spacing={1} direction="column" alignItems="center">
          <Checkbox
            value={cellData.examDay.id}
            checked={cellData.isChecked}
            onChange={handleChange(cellData.examDay)}
          />
          {cellData.examIds.map((examId, index) => (
            <Grid item key={examId + index}>
              <Chip label={getExamName(examId)} key={examId} />
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <React.Fragment>
      <TableRow key={location.id}>
        <TableCell component="th" scope="row">
          <Typography variant="h6">{location.name}</Typography>
        </TableCell>
        {cells.map((cellData, index) => {
          if (cellData instanceof FullCellData)
            return (
              <TableCell key={cellData.examDay.id} align="right">
                {cellContent(cellData)}
              </TableCell>
            );
          return <TableCell key={index} align="right" />;
        })}
      </TableRow>
    </React.Fragment>
  );
};

export default ExpertAvailabilityRow;
